import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import $ from 'jquery';
import Popper from 'popper.js';

import 'bootstrap/dist/css/bootstrap.css';


import './css/custom.css'
import './css/fa/css/font-awesome.css'

const isMock = process.env.REACT_APP_MOCK === '1';

// Real-login mode: withAuthenticator's custom component slots (SignIn.Footer /
// SignUp.Footer in comps/auth/theme/settings.js) call useAuthenticator(), which
// requires an <Authenticator.Provider> ancestor. The HOC alone does not supply
// it in @aws-amplify/ui-react v3, so wrap the root render here.
// Mock mode renders App directly (no Amplify) and must NOT load the provider.
let Root = <App />;
if (!isMock) {
  const { Authenticator } = require('@aws-amplify/ui-react');
  Root = (
    <Authenticator.Provider>
      <App />
    </Authenticator.Provider>
  );
}

ReactDOM.render(Root, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
